<svelte:options runes={false} />
<script>
  // Cadence (TASK-K2T-8): regularity, not just recency — bars observed vs the expected grid over the
  // trailing window (LiveStatusSurface shows only the LAST bar). Missed slots are enumerated so an
  // operator sees WHICH hours went dark, bounded server-side.
  export let cadence = null; // { windowHours, expected, observed, missedTimes }

  const MAX_CHIPS = 12;
  $: missed = cadence?.missedTimes ?? [];
  $: shown = missed.slice(0, MAX_CHIPS);
  function fmtSlot(t) {
    const d = new Date(t);
    return Number.isNaN(d.getTime()) ? String(t) : d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  }
</script>

{#if !cadence}
  <!-- contract-guaranteed; nothing to render if it is ever absent -->
{:else if cadence.expected === 0}
  <p class="it-cadence-empty">No bars in the trailing {cadence.windowHours}h window yet.</p>
{:else}
  <div class="it-cadence">
    <span class="it-cadence-headline num" class:it-cadence-clean={missed.length === 0}>
      {cadence.observed}/{cadence.expected} expected bars observed · trailing {cadence.windowHours}h
    </span>
    {#if missed.length > 0}
      <div class="it-cadence-missed">
        <span class="it-cadence-missed-label">missed:</span>
        {#each shown as t (t)}<span class="it-cadence-chip num">{fmtSlot(t)}</span>{/each}
        {#if missed.length > shown.length}<span class="it-cadence-chip it-cadence-more">+{missed.length - shown.length} more</span>{/if}
      </div>
    {/if}
  </div>
{/if}

<style>
  .it-cadence { display: flex; flex-direction: column; gap: 0.35rem; }
  .it-cadence-headline { font-size: 0.74rem; color: var(--warning, #d8a000); font-weight: 600; }
  .it-cadence-headline.it-cadence-clean { color: var(--text-secondary, #b5b6b8); font-weight: 400; }
  .it-cadence-missed { display: flex; flex-wrap: wrap; align-items: center; gap: 0.3rem; }
  .it-cadence-missed-label { font-size: 0.66rem; color: var(--text-muted, #8a8b8d); }
  .it-cadence-chip {
    font-size: 0.62rem; padding: 0.1rem 0.35rem; border-radius: 3px;
    background: rgba(224, 83, 58, 0.12); color: var(--danger, #e0533a);
  }
  .it-cadence-more { background: var(--surface-2, rgba(255, 255, 255, 0.05)); color: var(--text-muted, #8a8b8d); }
  .it-cadence-empty { margin: 0; font-size: 0.72rem; color: var(--text-muted, #8a8b8d); }
  .num { font-variant-numeric: tabular-nums; }
</style>
